import { detectDupes } from "@liveblocks/core";

import { PKG_FORMAT, PKG_NAME, PKG_VERSION } from "./version";

detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);

export type {
  Awaitable,
  BaseActivitiesData,
  BaseMetadata,
  BaseUserMeta,
  BroadcastOptions,
  Client,
  ClientOptions,
  CommentAttachment,
  CommentBody,
  CommentBodyBlockElement,
  CommentBodyElement,
  CommentBodyInlineElement,
  CommentBodyLink,
  CommentBodyLinkElementArgs,
  CommentBodyMention,
  CommentBodyMentionElementArgs,
  CommentBodyParagraph,
  CommentBodyParagraphElementArgs,
  CommentBodyText,
  CommentBodyTextElementArgs,
  CommentData,
  CommentLocalAttachment,
  CommentMixedAttachment,
  CommentReaction,
  EnsureJson,
  Feed,
  FeedCreateMetadata,
  FeedFetchMetadataFilter,
  FeedRequestError,
  FeedRequestFailedServerMsg,
  FeedUpdateMetadata,
  History,
  HistoryVersion,
  Immutable,
  InboxNotificationData,
  IUserInfo,
  Json,
  JsonArray,
  JsonObject,
  JsonScalar,
  LiveblocksErrorContext,
  LiveListUpdate,
  LiveMapUpdate,
  LiveObjectUpdate,
  LiveStructure,
  LostConnectionEvent,
  Lson,
  LsonObject,
  MentionData,
  NotificationChannel,
  NotificationChannelSettings,
  NotificationKind,
  NotificationSettings,
  OthersEvent,
  PlainLsonObject,
  ReadonlyJson,
  ReadonlyJsonObject,
  ResolveGroupsInfoArgs,
  ResolveMentionSuggestionsArgs,
  ResolveRoomsInfoArgs,
  ResolveUsersArgs,
  Room,
  RoomSubscriptionSettings,
  Status,
  StorageStatus,
  StorageUpdate,
  StringifyCommentBodyElements,
  StringifyCommentBodyOptions,
  ThreadData,
  ToJson,
  UploadAttachmentOptions,
  User,
} from "@liveblocks/core";
export {
  createClient,
  defineAiTool,
  FeedRequestErrorCode,
  getMentionsFromCommentBody,
  isNotificationChannelEnabled,
  LiveblocksError,
  LiveList,
  LiveMap,
  LiveObject,
  nanoid,
  shallow,
  stringifyCommentBody,
  toPlainLson,
} from "@liveblocks/core";
